const roundingDecimal = (num: number) => {
  return Math.round(num * 100) / 100;
};
export default roundingDecimal;
